export default __webpack_public_path__ + "static/media/3_Still.f0e603ad.jpg";